import * as React from 'react';
import { get } from 'lodash';
import { Model, Question } from 'survey-core';
import { SurveyQuestionElementBase } from 'survey-react-ui';
import { Box, TextField, Tooltip } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

export const TYPE = 'mui-text';

export class MuiTextFieldModel extends Question {
  getType(): string {
    return TYPE;
  }

  get limitInput() {
    return this.getPropertyValue('limitInput');
  }
  set limitInput(val) {
    this.setPropertyValue('limitInput', val);
  }

  get inputType() {
    return this.getPropertyValue('inputType');
  }
  set inputType(val) {
    this.setPropertyValue('inputType', val);
  }

  get tooltip() {
    return this.getPropertyValue('tooltip');
  }
  set tooltip(val) {
    this.setPropertyValue('tooltip', val);
  }
}

export class MuiTextField extends SurveyQuestionElementBase {
  constructor(props: any) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  get question() {
    return this.questionBase;
  }

  get limitInput() {
    return this.question.limitInput;
  }

  handleChange({ target: { value } }: React.ChangeEvent<HTMLInputElement>) {
    const { inputType } = this.question;
    if (this.limitInput && !new RegExp(this.limitInput).test(value)) {
      return;
    }
    this.question.value = inputType === 'number' && value ? parseInt(value) : value;
  }

  protected renderElement(): JSX.Element | null {
    const model = this.question.survey as Model;
    const { value = '', title, isRequired, tooltip } = this.question;
    const { location } = model.getVariable('info');
    const tooltipText = get(tooltip, location, tooltip);

    return (
      <Box display="flex" alignItems="center" width={400} paddingBottom={1}>
        <TextField
          label={title}
          value={value}
          onChange={this.handleChange}
          required={isRequired}
          variant="filled"
          fullWidth
          InputProps={{
            readOnly: this.isDisplayMode
          }}
        />
        {tooltipText && (
          <Tooltip title={tooltipText} placement="right-start">
            <Box flexShrink={0} marginLeft={1}>
              <InfoOutlinedIcon />
            </Box>
          </Tooltip>
        )}
      </Box>
    );
  }
}
